import React from "react";

// The F mark — built from the Stitch-generated SVG (bars forming letter F in blue-to-cyan gradient)
export function Logo({ className = "size-8" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 250 280"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* Bar 1 — top arm, full width */}
      <rect y="0"   width="250" height="40" fill="#1152D4" />
      {/* Bar 2 — full width */}
      <rect y="48"  width="250" height="40" fill="#1B66DF" />
      {/* Bar 3 — stem only (40%) */}
      <rect y="96"  width="100" height="40" fill="#257AE9" />
      {/* Bar 4 — middle arm (80%) */}
      <rect y="144" width="200" height="40" fill="#2F8EF4" />
      {/* Bar 5 — stem only (40%) */}
      <rect y="192" width="100" height="40" fill="#39A2FF" />
      {/* Bar 6 — stem only (40%), cyan */}
      <rect y="240" width="100" height="40" fill="#06B6D4" />
    </svg>
  );
}
